<template>
  <div class="icon">
    <svg v-if="computedIcon === 'chevron-down'" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
    </svg>
    <svg v-else-if="computedIcon === 'clipboard-copy'" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" stroke="currentColor" viewBox="0 0 24 24"><path d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3"></path></svg>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: [String, Array],
      required: true
    }
  },

  computed: {
    computedIcon() {
      return Array.isArray(this.icon) ? this.icon[1] : this.icon
    }
  }
}
</script>